const initialState = {
  open: false,
  message: '',
  style: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'NOTIFICATION_SEND':
      return {
        open: true,
        message: action.payload,
        style: action.meta.style,
      }

    case 'NOTIFICATION_CLEAR':
      return {
        open: false,
        message: initialState.message,
        style: null,
      }
    default:
      return state
  }
}
